module.exports = {
  title: '用户汇总',
  route: {
    path: '/data-statistics',
    children: {
      path: 'data-user-summary',
    },
  },
};
